import * as Yup from 'yup'

const resources = {
  all: 'All',
  Appointment: 'Appointment',
  Accounting: 'Accounting',
  Calendar: 'Calendar',
  Customer: 'Customer',
  Invoice: 'Invoice',
  Payment: 'Payment',
  Vendor: 'Vendor',
  Bill: 'Bill',
  VenderPayment: 'Vendor Payment',
  Shipment: 'Shipment',
  Inventory: 'Inventory',
  InventorySetup: 'Inventory Setup',
  ServiceTicket: 'Service Ticket',
  Stylist: 'Stylist',
  Repair: 'Repair',
  RepairTicket: 'Repair Ticket',
  Request: 'Request',
  Specialist: 'Specialist',
  Service: 'Service',
  Setting: 'Setting',
  SystemSetting: 'System Setting',
  User: 'User',
  Role: 'Role',
  Message: 'Message',
  WigOrder: 'Wig Order'
}

const actions = {
  MANAGE: {label: 'Manage', value: 'manage'},
  READ: {label: 'Read', value: 'read'}
}

const headers = [
  {
    label: 'Name',
    id: 'name'
  },
  {
    label: 'Description',
    id: 'description'
  },
  {
    label: 'Created At',
    date: true,
    id: 'created_at'
  }
];

const filters = [
  {
    id: "created_at",
    type: "date",
    label: "Created At",
  }
]

const initialValues = {
  name: "",
  description: "",
  permissions: []
}

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "name",
    label: "Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "description",
    label: "Description",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: 'divider',
    size: {xs: 12, lg: 12},
    header: 'Select Resource Permissions',
  },
]

const schema = Yup.object().shape({});

export { headers, filters, fields, initialValues, schema, resources, actions };